import { render, staticRenderFns } from "./PlayPage.vue?vue&type=template&id=037528a6&scoped=true"
import script from "./PlayPage.vue?vue&type=script&lang=js"
export * from "./PlayPage.vue?vue&type=script&lang=js"
import style0 from "./PlayPage.vue?vue&type=style&index=0&id=037528a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037528a6",
  null
  
)

export default component.exports